module.exports = __webpack_public_path__ + "static/media/ico-search.588a6c6e.svg";